export const OfficeFinanceTextState = {
	url: '/finance-option-text/:type_id/:id',
	title: 'Office Finance Text',
	template: '<finance-option-text></finance-option-text>',
	params: {id: null, type_id: null, type_name: null},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeFinanceOptionTextPageMod" */
			'@Containers/office-finance-options/finance-option-text-only.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
